<template>
    <div ref="carousel" :id="id" class="carousel slide mb-4" v-if="announcements.length > 0">
        <div v-if="announcements.length > 1" class="carousel-indicators">
            <button v-for="(announcement, index) in announcements" type="button" :data-bs-target="'#' + id" :data-bs-slide-to="index" :class="{ active: index === 0 }" :aria-current="index === 0" :aria-label="'Slide ' + (index + 1)"></button>
        </div>
        <div class="carousel-inner rounded">
            <div v-for="(announcement, index) in announcements" class="carousel-item" :class="{ active: index === 0 }">
                <a v-if="announcement.openNewTab" :href="announcement.url" target="_blank"><img :src="announcement.image" class="d-block w-100" alt="..."></a>
                <a v-else :href="announcement.url"><img :src="announcement.image" class="d-block w-100" alt="..."></a>
            </div>
        </div>
        <button v-if="announcements.length > 1" class="carousel-control-prev" type="button" :data-bs-target="'#' + id" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button v-if="announcements.length > 1" class="carousel-control-next" type="button" :data-bs-target="'#' + id" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
</template>

<script>
import { mapActions } from 'pinia'
import { useAnnouncementsStore } from '../../stores/announcements';

export default {
    props: ['target'],

    async mounted() {
        const announcements = await this.getAnnouncements(this.target);

        this.announcements = announcements;

        await this.$nextTick();

        if(announcements.length === 0) {
            return;
        }

        new window.bootstrap.Carousel(this.$refs.carousel, {
            interval: 5000,
            ride: 'carousel',
        });
    },

    data() {
        return {
            id: this.target + 'Announcements',
            announcements: [],
        };
    },

    methods: {
        ...mapActions(useAnnouncementsStore, { getAnnouncements: 'get' })
    },
};
</script>
